import "./proposedTime.less";

import * as _ from 'lodash';
import { auditIncidents } from "../../objects/Audit";

/**
 * @typedef { import('./ProposedTimeGroupModel').ProposedTimeGroupModel } ProposedTimeGroupModel
 */

class ProposedTimeController {
    static $inject = ['tromanServer', 'downloadService', 'dialogService'];
    /**
     * @param {ApiServer} tromanServer
     * @param {any} downloadService
     * @param {any} dialogService
     */
    constructor(tromanServer, downloadService, dialogService) {
        this._tromanServer = tromanServer;
        this._downloadService = downloadService;
        this._dialogService = dialogService;
        this.editRejection = false;

        /** @type {ProposedTimeGroupModel} */
        this.paymentGroup = null;
        /** @type {PaymentLock} */
        this.paymentLock = null;
    }

    get rejectionForm() {
        return this._rejectionForm;
    }

    // A little hackish, force rejection form to be default dirty
    set rejectionForm(value) {
        this._rejectionForm = value;
        if (value) {
            value.$setDirty();
        }
    }

    $onChanges(changed) {
        if (changed.paymentGroup) {
            if (this.paymentGroup) {
                this.isSubstitute = this.paymentGroup.payslipModel.attendance.canServeAsSubstitute();                
                const rejections = _.filter(this.paymentGroup.payslipModel.attendance.TimeReport.AuditEntries, x => x.Incident === auditIncidents.timeRejected);
                this.lastRejection = _.maxBy(rejections, x => x.Timestamp);

                this.title = 'Ny närvarotid rapporterad från Troman Politiker';
            } else {
                this.timereport = null;
                this.title = null;
            }
        }
    }

    get isLocked() {
        return this.paymentLock.isLocked;
    }

    acceptTimeReport() {
        this.paymentGroup.accept();
    }

    rejectTimeReport() {
        this.paymentGroup.rejecting();
        this.paymentLock.lockGroup(this.paymentGroup);
    }

    confirmRejection() {
        this.paymentGroup.rejected();
        this.paymentLock.reset();
    }

    cancelRejection() {
        this.paymentGroup.reset();
        this.paymentLock.reset();
    }

    abortTimeReport() {
        this.paymentGroup.reset();
    }

    showDetails() {
        this._dialogService.showAttendanceTimeReport(this.paymentGroup.payslipModel.attendance);
    }
}

angular.module("tromanWeb").component('ergoProposedTime', {
    template: require('./proposedTime.html'),
    bindings: {
        paymentGroup: '<',
        paymentLock: '<',
        wageTypes: '<',
    },
    controller: ProposedTimeController,
});

